<template>
    <div class="login_out">
      <van-popover v-model="showPopover" theme="dark" trigger="click" placement="bottom-end" :actions="actions"
        @select="onSelect">
        <template #reference>
          <van-button type="primary">{{user.name || user.phone || ''}}</van-button>
        </template>
      </van-popover>
    </div>
</template>
<script>
import { cacheStorage } from '@/utils'
import store from '@/store'
export default {
    data() {
        return {
            showPopover: false,
            actions: [{ text: '退出登录' }],
            user: null,
        }
    },
    created () {
        let userInfo = cacheStorage.getItem(process.env.VUE_APP_USER)
        userInfo = JSON.parse(userInfo)
        this.user = userInfo
    },
    methods: {
        onSelect (action) {
            if (action.text === "退出登录") {
                cacheStorage.clear()
                this.$router.push('/login')
            }
        }
    }
}
</script>
<style lang="less" scoped>
.login_out {
  height: 30px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  /deep/ .van-button--primary {
    color: #1e6eff;
    border: 0;
    background: #fff;
    text-align: right;
  }
}
</style>